import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const PlaySvg = () => (
  <svg width='26' height='19' viewBox='0 0 26 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_49_5924)'>
      <path
        d='M23.9756 4.00594C23.8568 3.53135 23.6149 3.09651 23.2743 2.74534C22.9337 2.39418 22.5064 2.13912 22.0356 2.00594C20.3156 1.58594 13.4356 1.58594 13.4356 1.58594C13.4356 1.58594 6.55563 1.58594 4.83563 2.04594C4.36488 2.17912 3.93761 2.43418 3.59698 2.78534C3.25635 3.13651 3.01442 3.57135 2.89563 4.04594C2.58084 5.79149 2.42687 7.56225 2.43563 9.33594C2.42441 11.123 2.5784 12.9072 2.89563 14.6659C3.02659 15.1258 3.27394 15.5441 3.61377 15.8804C3.95361 16.2168 4.37445 16.4598 4.83563 16.5859C6.55563 17.0459 13.4356 17.0459 13.4356 17.0459C13.4356 17.0459 20.3156 17.0459 22.0356 16.5859C22.5064 16.4528 22.9337 16.1977 23.2743 15.8465C23.6149 15.4954 23.8568 15.0605 23.9756 14.5859C24.288 12.8535 24.442 11.0963 24.4356 9.33594C24.4469 7.54889 24.2929 5.76464 23.9756 4.00594Z'
        stroke='url(#paint0_linear_49_5924)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.1851 12.6025L16.9351 9.3325L11.1851 6.0625V12.6025Z'
        stroke='url(#paint1_linear_49_5924)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_49_5924'
        x1='2.43506'
        y1='1.58594'
        x2='25.2084'
        y2='2.82223'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_49_5924'
        x1='11.1851'
        y1='6.0625'
        x2='17.1477'
        y2='6.26248'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <clipPath id='clip0_49_5924'>
        <rect width='25' height='18' fill='white' transform='translate(0.739746 0.585938)' />
      </clipPath>
    </defs>
  </svg>
);

export const PlayColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PlaySvg} {...props} />
);
